import React from 'react';
import BottomSheet from '@/components/BottomSheet';
import {
  IUserStatusBottomSheetContainerProps,
  UserStatusBottomSheetContainer,
} from '../components';
import { useGetUserStatus } from './userStatusData';

type TOpenUserStatusBottomSheetProps = Pick<
  IUserStatusBottomSheetContainerProps,
  'children'
> & {
  delay?: number;
  onOpen?: () => void;
};

export const useOpenUserStatusBottomSheet = () => {
  const { status, ...restUserStatusData } = useGetUserStatus();

  return ({
    children,
    delay = 0,
    onOpen,
  }: TOpenUserStatusBottomSheetProps = {}) => {
    if (!status || status === 'VERIFIED') {
      return;
    }

    setTimeout(() => {
      BottomSheet.open({
        children: (
          <UserStatusBottomSheetContainer
            status={status}
            {...restUserStatusData}
          >
            {children}
          </UserStatusBottomSheetContainer>
        ),
      });
      onOpen?.();
    }, delay);
  };
};
